import {
  Image,
  Pressable,
  StyleSheet,
  TouchableOpacity,
  View,
} from "react-native";
import React, { useCallback, useRef, useState } from "react";
import { SCREEN_WIDTH, fp, hp, spH, spV, wp } from "utils/normalizeV2";

import Carousel from "react-native-reanimated-carousel";
import { Colors } from "colors";
import ImageView from "../../src/image";
import { Images } from "assets";
import VText from "components/VText";
import { useRouter } from "expo-router";
import Heading from "components/Heading";
const StoriesScroll = ({ data, gender }) => {
  const [currentActiveIndex, setCurrentActiveIndex] = useState(0);

  const router = useRouter();
  const _slider1Ref = useRef();

  const _renderItem = useCallback(
    ({ item, index }) => {
      return (
        <View
          key={item?.id || index}
          style={{
            flex: 1,
            paddingRight: wp(24),
            width: wp(425),
          }}
        >
          <Pressable
            key={index}
            activeOpacity={1}
            onPress={() => {
              router.push(
                `${gender == "men" ? "/men" : ""}/stories-details/${
                  item?.id
                }/${item?.title
                  .toLowerCase()
                  .replace(" ", "-")}?source=story_listing_image`
              );
            }}
            style={[styles.categoryCard]}
          >
            <ImageView
              alt={item?.title}
              resizeMode={ImageView.resizeMode.cover}
              source={{
                priority: ImageView.priority.high,
                uri: item?.imageUrl,
              }}
              style={styles.categoryImage}
            />
          </Pressable>
          <View
            style={{
              paddingTop: spV(20),
            }}
          >
            <Heading type="h3" numberOfLines={1} style={styles.itemTitle}>
              {item?.title}
            </Heading>
            <Heading type="h5" numberOfLines={2} style={styles.subTitle}>
              {item?.subTitle}
            </Heading>

            <TouchableOpacity
              style={styles.button}
              onPress={() => {
                router.push(
                  `${gender == "men" ? "/men" : ""}/stories-details/${
                    item?.id
                  }/${item?.title
                    .toLowerCase()
                    .replace(" ", "-")}?source=story_listing_cta`
                );
              }}
            >
              <VText style={styles.buttonText}>
                {item?.cta ? item?.cta : "Read More"}
              </VText>
            </TouchableOpacity>
          </View>
        </View>
      );
    },
    [data, gender]
  );

  return (
    <View style={styles.container}>
      <Carousel
        loop={data?.length > 3} // Only enable loop when there are multiple items
        width={wp(425)}
        // height={hp(700)}
        style={{
          width: wp(SCREEN_WIDTH - 184),
          minHeight: hp(800),
        }}
        autoFill={true} // Add this to prevent empty space
        overscrollEnabled={false}
        ref={_slider1Ref}
        scrollEnabled={false}
        data={data}
        scrollAnimationDuration={1000}
        renderItem={_renderItem}
        onSnapToItem={(index) => setCurrentActiveIndex(index)}
      />
      <TouchableOpacity
        style={[styles.navButton, styles.navButtonLeft]}
        onPress={() => {
          _slider1Ref?.current?.prev({
            animated: true,
            count: 1,
          });
        }}
      >
        <Image
          accessibilityLabel="Left Arrow"
          style={styles.navButtonImage}
          source={Images.left}
        />
      </TouchableOpacity>
      <TouchableOpacity
        style={[styles.navButton, styles.navButtonRight]}
        onPress={() => {
          _slider1Ref?.current?.next({
            animated: true,
            count: 1,
          });
        }}
      >
        <Image
          accessibilityLabel="Right Arrow"
          style={styles.navButtonImage}
          source={Images.right}
        />
      </TouchableOpacity>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    marginVertical: 20,
    marginTop: hp(28),
    paddingHorizontal: wp(92),
  },
  button: {
    marginTop: 5,
  },
  headingText: {
    fontFamily: "Libre Bodoni",
    fontWeight: "500",
    textAlign: "left",
    fontSize: 40,
    fontWeight: "600",
    color: Colors.black,
    alignSelf: "center",
  },
  navButton: {
    position: "absolute",
    top: "35%",
    borderRadius: 20,
    padding: 10,
  },
  categoryCard: {},
  categoryCardNonHovered: {
    width: spH(429),
    height: 400,
    marginHorizontal: 0,
  },
  categoryImage: {
    width: wp(401),
    height: wp(537),
    backgroundColor: Colors.grey1,
    resizeMode: "cover",
  },
  buttonText: {
    fontFamily: "JosefinSans",
    fontSize: fp(20),
    color: "#000",
    textDecorationLine: "underline",
  },
  itemTitle: {
    fontFamily: "LibreBodoni",
    fontSize: fp(24),
    fontWeight: "200",
  },
  subTitle: {
    fontFamily: "JosefinSans",
    fontWeight: "350",
    fontSize: fp(20),
    color: Colors.black,
    marginTop: 5,
    lineHeight: "140%",
    minHeight: (fp(20) + fp(20) * 0.4) * 2,
  },
  navButtonLeft: {
    left: 30,
  },
  navButtonRight: {
    right: 30,
  },
  navButtonImage: {
    height: spH(30),
    width: spH(30),
  },
});

export default StoriesScroll;
